import { defineComponent as _defineComponent } from 'vue'
import {getEngineerList, getListAdd} from '@/api/miscellaneous';
import {ref} from 'vue';
import {useRouter} from 'vue-router';
import ListItemAd from '@/components/ListItemAd.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'EngineeringList',
  setup(__props, { expose }) {
  expose();

const {push} = useRouter();
const getListData = ref({
    page: 1,
    size: 10,
});
const list = ref<any[]>([]);
const addList = ref<any[]>([]);
const loading = ref(false);
const finished = ref(false);

const getList = () => {
    if (loading.value) return;
    loading.value = true;
    getEngineerList(getListData.value).then(res => {
        loading.value = false;
        list.value = [...list.value, ...res.items];
        getListData.value.page = getListData.value.page + 1;
        finished.value = res.totalCount == 0 ? true : getListData.value.page * getListData.value.size > res.totalCount;
    });
};

const getAdd = () => {
    getListAdd({keywords: '广告位用勿动处理求购供应列表中'}).then((res: any) => {
        addList.value = JSON.parse(res.contentJson);
        getList();
    });
};
getAdd();

const __returned__ = { push, getListData, list, addList, loading, finished, getList, getAdd, getEngineerList, getListAdd, ref, useRouter, ListItemAd }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})